<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('layout_profilo_tooltip')}}</h1></div>

            <div class="content container">

                <div class="row row-sezione" style="margin:auto;">
                    <div class="col-md-6 col-lg-3">
                        <router-link :to="{name:'user.edit'}" class="btn btn-app a2">
                          <span class="material-symbols-outlined icone30">
                              person
                          </span>
                          <br>{{$t('account.dati_utente')}}
                        </router-link>
                    </div>
                    <div class="col-md-6 col-lg-3" v-if="this.f_stripe">
                        <router-link :to="{name: 'user.payments'}" class="btn btn-app a2">
                            <span class="material-symbols-outlined icone30">
                              credit_card
                            </span>
                          <br>{{$t('metodi_pagamento_title')}}
                        </router-link>
                    </div>
                    <div class="col-md-6 col-lg-3" v-if="this.locale_delivery_active">
                        <router-link :to="{name: 'user.addresses'}"
                                     class="btn btn-app a2">
                            <span class="material-symbols-outlined icone30">
                              home_pin
                            </span>
                          <br>{{$t('account.gestione_indirizzi')}}
                        </router-link>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <router-link :to="{name:'orders.history'}" class="btn btn-app a2">
                            <span class="material-symbols-outlined icone30">
                              receipt_long
                            </span>
                          <br>{{$t('account.storico_ordini')}}
                        </router-link>
                    </div>
                    <div class="col-md-6 col-lg-3" v-if="this.enable_reservations">
                        <router-link :to="{name:'reservations.history'}" class="btn btn-app a2">
                            <span class="material-symbols-outlined icone30">
                              calendar_meal
                            </span>
                          <br>{{$t('prenotazione.storico')}}
                        </router-link>
                    </div>

                  <div class="col-md-6 col-lg-3" v-if="this.enable_messaging">
                    <router-link to="messaggistica" class="btn btn-app a2">
                      <span class="material-symbols-outlined icone30">
                              mark_as_unread
                            </span>
                      <br>{{$t('messaggistica')}}
                    </router-link>
                  </div>

                  <div class="col-md-6 col-lg-3" v-if="this.enable_coupons">
                    <router-link to="ordine/sconti" class="btn btn-app a2">
                      <span class="material-symbols-outlined icone30">
                              percent_discount
                            </span>
                      <br>{{$t('layout_opzioni_label_csconto_tooltip')}}
                      <span class="badge badge-info">{{ this.counter_discount_codes }}</span>
                    </router-link>
                  </div>

                  <div class="col-md-6 col-lg-3" v-if="this.enable_fidelity_card">
                    <router-link to="fidelity/" class="btn btn-app a2">
                      <span class="material-symbols-outlined icone30">
                              redeem
                            </span>
                      <br>{{$t('layout_fidelity_card')}}
                    </router-link>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <router-link to="sondaggio" class="btn btn-app a2">
                      <span class="material-symbols-outlined icone30">
                              cards_star
                            </span>
                      <br>{{$t('sondaggio')}}
                    </router-link>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <router-link to="notifiche" class="btn btn-app a2">
                      <span class="material-symbols-outlined icone30">
                              notifications_active
                            </span>
                      <br>{{$t('layout_notifiche')}}
                    </router-link>
                  </div>

                    <div class="col-md-6 col-lg-3" v-for="checkbox in this.checkboxes">
                        <a href="#" class="btn btn-app a2" @click.prevent="openPrivacyModal(checkbox)">
                            <span class="material-symbols-outlined icone30">
                              privacy_tip
                            </span>
                          <br>{{checkbox.label}}
                        </a>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-4 col-lg-3 my-4 text-center">
                        <a href="#" @click.prevent="handleLogout()" class="btn btn-primary w-100">
                            <div class="d-flex align-items-center justify-content-center">
                              <span class="material-symbols-outlined">lock</span>
                              Logout
                            </div>
                        </a>
                    </div>
                </div>
              <div class="row justify-content-center">
                <div class="col-md-4 col-lg-3 mt-2 mb-4 text-center">
                    <a href="#" @click.prevent="show_modal_delete_account = true" class="btn btn-danger rounded-pill w-100">
                      <div class="d-flex align-items-center justify-content-center">
                        <span class="material-symbols-outlined">delete</span>
                        Elimina account
                      </div>
                    </a>
                  </div>
                </div>
            </div>
        </div>
        <modal v-if="this.show_modal_delete_account" @close="show_modal_delete_account = false" :show-title="true" :size="'medium'">
            <div slot="header">
                <h5 class="modal-title">{{$t('account.delete_title')}}</h5>
            </div>
            <div slot="body">
                <p>{{$t('account.delete_warning')}}</p>
                <p>{{$t('account.delete_description')}}</p>
            </div>
            <div slot="footer" class="flex-fill">
                <button type="button" class="btn btn-default float-left" @click="show_modal_delete_account = false">
                    {{$t('btn_annulla')}}
                </button>
                <button type="button" class="btn btn-danger float-right text-white" @click="handleDeleteAccount()">
                    {{$t('account.delete_confirm')}}
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from 'vuex';
import {deleteAccount} from "../../api/account";
import {getPrivacyCheckboxes} from "../../api/restaurant";

import Modal from "../partials/Modal";
import router from "../../routes";

export default {
    name: "UserMenu",
    inject: {
        privacyModalProvider: {
            from: 'openPrivacyModal',
            default: null
        }
    },
    components: {Modal},
    data() {
        return {
            show_modal_delete_account: false,
            checkboxes: []
        };
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapGetters('restaurant', {
            locale_delivery_active: 'localeDeliveryActive',
            enable_reservations: 'enableReservations',
            enable_messaging: 'enableMessaging',
            enable_coupons: 'enableCoupons',
            enable_fidelity_card: 'enableFidelityCard',


        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale,
            f_stripe: state => state.f_stripe
        })
    },
    watch: {
        language: function () {
            this.fetch();
        }
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getPrivacyCheckboxes(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                for_general: true
            }).then((response) => {
                this.checkboxes = response.checkboxes;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        openPrivacyModal: function (checkbox) {
            if (this.privacyModalProvider) {
                this.privacyModalProvider(checkbox);
            }
        },
        handleLogout: function () {
            this.removeUserData();
            router.replace('/');
        },
        handleDeleteAccount: function () {
            this.show_modal_delete_account = false;
            this.showLoading(true);
            deleteAccount(this.language, {
                id_ristorante: this.id_ristorante,
                email: this.user.email,
                api_key: this.user.api_key
            }).then(() => {
                this.removeUserData();
                router.replace('/');
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        ...mapActions('auth', [
            'removeUserData'
        ]),
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
